/** @jsx jsx */
import PropTypes from 'prop-types'
import { Box, Grid, jsx } from 'theme-ui'
import FooterContact from '~/components/Footer/Contact'
import FooterLinksSection from '~/components/Footer/Links/Section'
import FooterSocial from '~/components/Footer/Social'

const FooterLinks = ({ sections }) => {
  return (
    <Grid columns={[1, null, null, 2]} sx={{ rowGap: '0' }}>
      <Box>
        {sections.slice(0, 3).map(({ title, pages }, index) => (
          <FooterLinksSection title={title} pages={pages} key={index} />
        ))}
      </Box>
      <Box>
        {sections.slice(3).map(({ title, pages }, index) => (
          <FooterLinksSection title={title} pages={pages} key={index} />
        ))}
        <Box
          as="nav"
          role="navigation"
          aria-label="Footer Contact Us navigation"
          mb={[5, null, 6, 7]}
          sx={{ display: [null, 'none', null, 'block'] }}
        >
          <FooterContact />
        </Box>
        <Box
          as="nav"
          role="navigation"
          aria-label="Footer Follow Us navigation"
          mb={[6, null, 0]}
          sx={{ display: [null, 'none', null, 'block'] }}
        >
          <FooterSocial />
        </Box>
      </Box>
    </Grid>
  )
}

FooterLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ),
}

export default FooterLinks
